/** Subsequence match of `query` against `target`, case-insensitive. Returns `null` when `query`
 * isn't a subsequence of `target`; otherwise a score that rewards matches starting right after a
 * word boundary (space, `/`, `-`, `_`) — so "fd" ranks `foo/data.ts` above `xafdx`. */
export function fuzzyMatch(query: string, target: string): number | null {
  const q = query.toLowerCase();
  const t = target.toLowerCase();
  let qi = 0;
  let score = 0;

  for (let ti = 0; ti < t.length && qi < q.length; ti++) {
    if (t[ti] === q[qi]) {
      if (ti === 0 || t[ti - 1] === ' ' || t[ti - 1] === '/' || t[ti - 1] === '-' || t[ti - 1] === '_') {
        score += 5;
      }
      score += 1;
      qi++;
    }
  }

  return qi === q.length ? score : null;
}
